module.exports = __webpack_public_path__ + "img/icon-qq.3d36631e.png";